// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__9hzeq","container":"styles_container__YvDEK","valuesContainer":"styles_valuesContainer__idpx3"};